module.exports = __webpack_public_path__ + "static/media/rating-star-grey.b5ae230d.svg";